import React, { useState, useEffect, useContext } from 'react';
import { Container, Header, LineChart } from '@amzn/awsui-components-react-v3';
import { StateContext } from './context/spotcp-context';
import { STATUS_FINISHED, STATUS_LOADING } from './elements';
import _ from 'lodash';

// column name should be consistent what backend defined
const TIME_FA = 'time-FA';
const TIME_LA = 'time-LA';

export const Trend = (props) => {
  const { trendData } = useContext(StateContext);

  const [chartStatus, setChartStatus] = useState([STATUS_LOADING]);
  const [linechartData, setLinecharttData] = useState([]);
  const [xDomain, setXdomain] = useState([]);
  const [visibleSeries, setVisibleSeries] = useState([]);

  useEffect(() => {
    getLinechartData();
  }, [trendData])

  const generateData = (row, domain) => {
    return domain.map((d, i) => {
      return {x: d, y: Math.round(row[i] * 100) / 100}
    })
  }

  const getLinechartData = () => {
    setChartStatus(STATUS_LOADING);
    if (trendData && _.has(trendData, TIME_FA) && _.has(trendData, TIME_LA)) {
      const faDomain = (trendData[TIME_FA] || []).map(t => Math.round(t));
      const laDomain = (trendData[TIME_LA] || []).map(t => Math.round(t));
      setXdomain(faDomain); // use FA time series as chart domain as FA should always has more data
      const newChartData = Object.keys(trendData).filter(k => !k.startsWith('time')).map(component => {
        let domain = component.endsWith('-LA') ? laDomain : faDomain;
        return {
          title: `${component}`,
          type: 'line',
          data: generateData(trendData[component], domain),
          valueFormatter: (t) => t.toLocaleString('en-US') + '%',
        }
      });
      setLinecharttData(newChartData);
      setVisibleSeries(newChartData.filter(c => (c.title.startsWith('Total'))))
      setChartStatus(STATUS_FINISHED);
    }
  }

  return (
    <Container
      className="custom-dashboard-container"
      header={
        <Header variant="h2" description="Trend of past 12 months">
          Accuracy Trend
        </Header>
      }
    >
      <LineChart
        series={linechartData}
        xDomain={xDomain}
        yDomain={[0, 100]}
        i18nStrings={{
          filterPlaceholder: 'Filter data',
          yTickFormatter: (t) => t + '%',
        }}
        errorText="Error loading data."
        height={300}
        loadingText="Loading chart"
        statusType={`${chartStatus}`}
        xScaleType='categorical'
        xTitle='Accuracy Trend'
        yTitle='%'
        visibleSeries={ visibleSeries }
        onFilterChange={(e) => setVisibleSeries(e.detail.visibleSeries)}
      />
    </Container>
  );
};


// WEBPACK FOOTER //
// ./src/components/spotcp/trend.jsx